// Which planning item types the Movetex auto-send cron pushes by itself. Every type here must be
// a Movetex-enabled type of the tenant (MOVETEX_ENABLED_PLANNING_ITEM_TYPES). The rule per type
// lives in the backend: maintenance is sent per calendar month (the current and the next month),
// every other type when its suggested date falls within the lead time, overdue included.
export interface IMovetexAutoSendSettings {
    planningItemTypes: string[];
    // Belgian date (YYYY-MM-DD) stamped by the backend the first time maintenance joins the list
    // and never moved afterwards: maintenances suggested before that day are never auto-sent, the
    // backlog that existed at activation stays a manual push. Switching maintenance off later is
    // a pause; switching it back on resumes with the same cut-off.
    maintenanceActivatedOn: string | null;
}

export const MOVETEX_AUTO_SEND_SETTINGS_FALLBACK: IMovetexAutoSendSettings = {
    planningItemTypes: [],
    maintenanceActivatedOn: null,
};
